module.exports = __webpack_public_path__ + "img/icons8-networking-manager (2) 1.6c3d9939.svg";